/**
 * Created by henian.xu on 2020/5/9.
 *
 */

import Vue from 'vue';
import { mapGetters } from 'vuex';
import { Api } from 'api/index';
import { isDef } from 'utils/index';

export const state = Vue.observable({
    invoiceDetail: null,
});

export async function getInvoiceDetail(orderId) {
    const { data } = await Api.Member.Ex.OrderInvoice.invoiceDetail({
        orderId,
    });
    state.invoiceDetail = data;
}

export const invoiceAddMixin = {
    computed: {
        ...mapGetters('User', ['userInfo']),
    },
    methods: {
        async onAddOnlineInvoice() {
            const { userInfo, isCanInvoice, orderId, invoiceStatus, invoiceLineType } = this;
            if (isDef(isCanInvoice)) {
                if (isCanInvoice) {
                    this.$router.push(`/invoice/method?orderId=${orderId}`);
                    return;
                }
                if (invoiceStatus) {
                    if (invoiceLineType === 1) {
                        this.$router.push(`/invoice/detail/${orderId}`);
                    } else {
                        this.$router.push(`/invoice/offlineClaim?orderId=${orderId}`);
                    }
                    return;
                }
            }
            if (!userInfo.isAllowOrderInvoice) {
                this.$messageBox.alert(userInfo.orderInvoiceTips);
                return;
            }
            if (this.$globalVar.orderInvoiceNoticeImage) {
                const xImage = this.$createElement('XImage', {
                    props: {
                        src: this.$globalVar.orderInvoiceNoticeImage,
                    },
                });
                await this.$messageBox.confirm(xImage, '开票须知', { delayConfirm: 10 });
            }

            // this.$router.push(`/invoice/add/${data.id}`);
            this.onCreateOrderOnlineInvoice();
        },
        async onCreateOrderOnlineInvoice() {
            const { data } = await this.$api.Member.Ex.OrderInvoice.createOrderInvoice({
                orderId: this.orderId,
                invoiceType: this.$route.query.invoiceType || '',
            });
            /* if (!this.$route.query.invoiceType) {
            await this.$messageBox.alert(
                '线上平台仅能开具电子普通发票，如需开具纸质发票，需前往学校进行现场开票。',
            );
            } */
            if (!data) return;
            window.location.href = data;
        },
        async onAddOfflineInvoice() {
            if (this.$globalVar.orderInvoiceOfflineNoticeImage) {
                const xImage = this.$createElement('XImage', {
                    props: {
                        src: this.$globalVar.orderInvoiceOfflineNoticeImage,
                    },
                });
                await this.$messageBox.confirm(xImage, '开票须知', { delayConfirm: 10 });
            }
            await this.$api.Member.Ex.OrderInvoiceOffline.create({ orderId: this.orderId });
            this.$router.push(`/invoice/offlineClaim?orderId=${this.orderId}`);
        },
    },
};
